import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { translate } from '@openclassrooms/translations';
import { SlotNames } from '../constants/blueshift';
import type { SlotNamesToDatas } from '..';
export const SHOULD_DISPLAY_MAINTENANCE_BANNER: boolean = false;
export default function useGetMaintenanceStaticContent(slot) {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      slotName: SlotNames.PopUp,
      slotDatas: []
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      slotName: SlotNames.NewFeature,
      slotDatas: []
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = translate("predictive_crm.top_banner.maintenance.body");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [t0, t1, {
      slotName: SlotNames.TopBanner,
      slotDatas: [{
        show: false,
        content: {
          storageKey: "maintenance_05_2025",
          body: t2,
          button: "",
          link: "",
          matchingUrl: ".*",
          isMatchingUrlRegExp: true,
          dataEvent: {
            type: "Banner",
            category: "Clicked::Top",
            action: "Promobar",
            label: "Maintenance"
          }
        }
      }]
    }];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const MAINTENANCE_CONTENTS = t3;
  let t4;
  if ($[4] !== slot) {
    t4 = MAINTENANCE_CONTENTS.find(content => content.slotName === slot);
    $[4] = slot;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4 as SlotNamesToDatas[T];
}